module.exports = __webpack_public_path__ + "img/our-work-03.fe9787f1.jpg";